import apiCall from './api'

const getDrivesCallback = (response,callback=null, failure=null,autoopen=true,currentDriveType='removable') => {
	try {
		let driveList = '<option>取り出し可能デバイスがありません</option>'
		if(response!=='')
		{
			if(window.driveState!==response['rows'])
			{
				window.driveState=response['rows']
				if(document.getElementById("drive_list"))
				{
					const drives = response['rows'].split(',')
					driveList = ''
					for(let driveIndex=0;driveIndex<drives.length;driveIndex++)
					{
						if(drives[driveIndex]!=='')
						{
							driveList += '<option value="'+drives[driveIndex]+'">'+drives[driveIndex]+'ドライブ</option>'
						}
					}
					//document.getElementById('multi_device').style.display='none'
					//document.getElementById('single_device').style.display='none'
					//document.getElementById('no_device').style.display='none'
					document.getElementById('drive_list').style.display='none'
					document.getElementById('open_drive_btn').style.display='none'
					const removeBtn = document.getElementById('remove_btn')
					if(removeBtn) removeBtn.style.display='none'
					const removeInfo = document.getElementById('remove_info')
					// if(removeInfo) removeInfo.style.display='none'
					//document.getElementById('device_name').innerHTML = ''
					document.getElementById('drive_control').style.width = '260px'
					switch(drives.length)
					{
						case 0:
						case 1:
							if(drives[0]==='')
							{
								//document.getElementById("no_device").style.display='inline'
								document.getElementById("drive_control").style.width = '80px'
							}
							else
							{
								//document.getElementById('single_device').style.display='inline'
								document.getElementById('device_name').innerHTML = '( '+drives[0]+': )'
								document.getElementById('open_drive_btn').style.display='block'
								//const removeBtn = document.getElementById('remove_btn')
								//if(removeBtn) removeBtn.style.display='block'
								const removeInfo = document.getElementById('remove_info')
								if(removeInfo) removeInfo.style.display='inline'
								document.getElementById('drive_control').style.width = '130px'
								document.getElementById('drive_list').innerHTML = driveList
							}
							break
						default:
							//document.getElementById('multi_device').style.display='inline'
							document.getElementById('drive_list').style.display='inline'
							document.getElementById('drive_list').innerHTML = driveList
							document.getElementById('open_drive_btn').style.display='block'
							//const removeBtn = document.getElementById('remove_btn')
							//if(removeBtn) removeBtn.style.display='block'
							const removeInfo = document.getElementById('remove_info')
							if(removeInfo) removeInfo.style.display='inline'
							break
					}
				}
				if(response['rows']!==''&&autoopen)
				{
					const findDrive = response['rows'].split(',')
					const driveType = document.getElementById('device_type').value
					if(driveType===currentDriveType)
					{
						for(let driveIndex=0;driveIndex<findDrive.length;driveIndex++)
						{
							apiCall('drive/open', findDrive[driveIndex])
						}
					}
				}
			}
		}
		if(callback!==null)
		{
			callback()
		}
	} catch(e) {
		console.log(e)
	}
}

window.getDrives = (driveType,callback=null, failure=null, autoopen=true) =>{
	apiCall('drive/list', driveType, (response)=>getDrivesCallback(response,callback,failure,autoopen,driveType))
}

window.openDrive = () =>{
	if(document.getElementById('drive_list'))
	{
		const drive = document.getElementById('drive_list').value
		if(drive)
		{
			apiCall('drive/open', drive)
		}
	}
}

window.openDriveCustom = () =>{
	if(document.getElementById('drive_list'))
	{
		const drive = document.getElementById('drive_list').value
		if(drive)
		{
			apiCall('drive/opencustom', drive)
		}
	}
}

const removeDriveCallback = (response,isFinal) => {
	const message = response['result']==='OK'?'安全な取り外しが可能です。':'操作に失敗しました。'
	if(isFinal) alert(message)
}

window.removeDrive = (callback=null) => {
	if(document.getElementById('drive_list'))
	{
		const list = document.getElementById('drive_list')
		if(list.options.length>0)
		{
			for(let index = 0; index<list.options.length; index++){
				const drive = list.options[index].value
				apiCall('drive/remove', drive, (response)=>removeDriveCallback(response,(index+1===list.options.length)))
			}
		}
		if(callback) setTimeout(callback,2000)
	}
}
